module.exports = __webpack_public_path__ + "4ea32e35d7903b633f10d7248b1fa7ee.pdf";